<mat-list class="search-menu-view-selector common-search-menu">
  @for (view of searchContainer.searchResultViews.views; track $index) {
    <ng-container>
      <button
        mat-menu-item
        (click)="setCurrentView(view)"
        [ngClass]="{'active':searchContainer.searchResultViewName === view.name}"
      >
        <mat-icon>
          {{view.icon}}
        </mat-icon>

        <span>
          {{ view.description | translate }}
        </span>
      </button>
    </ng-container>
  }
</mat-list>
